import axios from 'axios'
import errorHandlerRest, { errorHandlerRestV2 } from './errorHandlerRest'
import { Cookie } from '@/mixin/local-cookie'

const axiosConfig = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
}

/*
 * NOTE:
 * apiClientV2 is created since we need to handle toast message from
 * parent completely, since apiClient (v1) is used in existing code,
 * removing the toast message will break the existing code.
 */
const apiClient = axios.create(axiosConfig)
export const apiClientV2 = axios.create(axiosConfig)

// TODO: Workaround
// When developing locally, the cookie 'resource' cookie is not available
// in the browser (httpOnly).
// So we need to manually copy the cookie after identity login
// and paste it to the localhost cookie
const localCookie = Cookie.getLocalCookie()

function setLocalCookie(config) {
  // If the local cookie is found (not httpOnly), then use it
  // if not, then use the httpOnly cookie, using withCredentials flag
  if (localCookie?.resource) {
    config.headers.Authorization = `Bearer ${localCookie?.resource}`
  } else {
    config.withCredentials = true
  }

  return config
}

apiClient.interceptors.request.use(setLocalCookie)
apiClientV2.interceptors.request.use(setLocalCookie)

apiClient.interceptors.response.use((response) => response, errorHandlerRest)
apiClientV2.interceptors.response.use((response) => response, errorHandlerRestV2)

/**
 * @param {import("axios").AxiosRequestConfig} requestConfig
 */
export const defaultClient = async (requestConfig) => {
  const response = await apiClient({
    ...requestConfig,
  })

  return response?.data
}

/**
 * @param {import("axios").AxiosRequestConfig} requestConfig
 */
export const defaultClientV2 = async (requestConfig) => {
  const response = await apiClientV2({
    ...requestConfig,
  })

  return response?.data
}

export default apiClient